import { useLocation, useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useState, useRef } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { GridLoader } from "react-spinners";
import {TopBar} from '../components/topbar';
import { MenuContext } from "../context/MenuContext";
import { IoMdArrowRoundBack } from "react-icons/io";
import { FaBold, FaItalic } from "react-icons/fa";
import { TostMessageContext } from "../context/TostMessage";
import {useCart} from '../hooks/add_to_cart';

export default function AddProduct() {
    const navigate = useNavigate();
    const {logOutFunction} = useContext(UserContext);
    const [cookies] = useCookies();
    const editorRef = useRef(null);
    const [content, setContent] = useState("");
    const [formFields, setFormFields] = useState({ new_category: "" });
    const [pageLoading, setPageLoading] = useState(false);
    const { menuOpen, setMenuOpen } = useContext(MenuContext)
    const [categoryFilter, setCatFilter] = useState('');
    const [subCategoryFilter, setSubCatFilter] = useState("");
    const [subCategories, setSubCat] = useState([]);
    const [fontSize, setFontSize] = useState(3); // 1–7 (default = 3)
    const [images, setImages] = useState([]);
    const {setTostMessage} = useContext(TostMessageContext)
    const {state} = useLocation();
    const {product_id} = useParams();
    const [pageData, setPageData] = useState(state?.row);
    const {formatAmount,parse} = useCart();

    const [extras, setExtras] = useState([
        { extra_group: "", extra_option: "", amount_plus: "" }
      ]);

    const increaseFontSize = () => {
        const newSize = Math.min(fontSize + 1, 7);
        setFontSize(newSize);
        exec("fontSize", newSize);
    };

    const decreaseFontSize = () => {
        const newSize = Math.max(fontSize - 1, 1);
        setFontSize(newSize);
        exec("fontSize", newSize);
    };

    const exec = (command, value = null) => {
        editorRef.current?.focus();
        document.execCommand(command, false, value);
        setContent(editorRef.current.innerHTML);
    };

    useEffect(() => {
        if (menuOpen) setMenuOpen(false);
        console.log(pageData);
        // if (product_id != undefined) getData();
    }, [])

    async function getData() {
        const formData = new FormData();
        formData.append('product_id', product_id);
        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/get_product_details_edit.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            setPageLoading(false)
            if (response.data.status) {
                setPageData(response.data)
                console.log(response.data.images)
                setImages(response.data.images)
            } else {

            }
        } catch (error) {
          setPageLoading(false)
        }
    }

    async function getCollections(value) {
        const formData = new FormData();
        formData.append('category_filter', value);
        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/get_collections.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            setPageLoading(false)
            if (response.data.status) {
              setSubCat(response.data.sub_categories);
            } else {

            }
        } catch (error) {
          setPageLoading(false)
        }
    }

    const addFilter = (value, category) => {
        // if (categoryFilter != "" && value) {
        //     setTostMessage({
        //         messageType: 'warning',
        //         message: 'You can only select one category at a time'
        //     })
        //     return;
        // }
        if (value) {
            setCatFilter(category)
            getCollections(category);
        } else {
            setCatFilter('');
            getCollections('');
        }
    }

    const addSubFilter = (value, category) => {
        console.log(category, value);
        if (value) {
            setSubCatFilter(category)
        } else {
            setSubCatFilter('');
        }
        // resetData();
    }

    const addRow = () => {
        const prev_group = extras[extras?.length-1].extra_group;
        setExtras([
            ...extras,
            { extra_group: prev_group, extra_option: "", amount_plus: "" }
        ]);
    };

    const removeRow = (index) => {
        setExtras(extras.filter((_, i) => i !== index));
    };

    const handleChange = (index, field, value) => {
        const updated = [...extras];
        updated[index][field] = value;
        setExtras(updated);
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files); // FileList → Array
        setImages((prev) => [...prev, ...files]);
    };

    const submit = async () => {
        const formData = new FormData();
        Object.entries(formFields).forEach(([key, value]) => {
          formData.append(key, value);
        });
        formData.append('category_filter', categoryFilter);
        formData.append('sub_category_filter', subCategoryFilter);
        formData.append('addons', JSON.stringify(extras));
        images.forEach((image, index) => {
            formData.append(`images[]`, image);
        });

        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/create_product.php', formData, {
                headers: {
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            setPageLoading(false)
            if (response.data.status) {
                setTostMessage({
                    messageType: 'success',
                    message: response.data.message
                })
                setImages([]);
                setCatFilter('');
                setSubCatFilter('');
                setFormFields({ new_category: "" })
                setExtras([{ extra_group: "", extra_option: "", amount_plus: "" }])
                setContent("");
                editorRef.current.innerHTML = "";
                // window.location.reload();
            } else {
                setTostMessage({
                    messageType: 'error',
                    message: response.data.message
                })
            }
        } catch (error) {
            setPageLoading(false)
            setTostMessage({
                messageType: 'error',
                message: 'Network Error'
            })
        }
    }

  return (
    <div className="flex flex-col rounded-[10px] min-h-full bg-white">
      {pageLoading && (
      <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
        <GridLoader
            color={'#7d5af6'}
            loading={true}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
      </div>
      )}
        {/* <h2 className="text-2xl text-[#037684] font-bold mb-4">Welcome, {userProfile?.name}</h2> */}
        <TopBar title={`Welcome, Admin`} />
        <div className="py-6 px-6 flex flex-col justify-start">
            <div className="flex items-center justify-start gap-x-3">
                <button onClick={() => navigate(-1)} className="p-2 border border-2 rounded-full"><IoMdArrowRoundBack size={20} /></button>
                <h2 className="text-2xl text-black font-bold">{'Manage Product'}</h2>
            </div>
            <div className="max-w-7xl w-full mx-auto px-4 py-6">
                <div className="w-full flex flex-col md:flex-row gap-6">
                    <div className="flex flex-col">
                    <h1 className="text-lg font-bold text-gray-800 mb-6">Set Category</h1>
                    <aside className="relative md:sticky md:top-10 h-[min-content] block w-full md:w-64 bg-white p-4 border rounded">
                        {/* <FilterGroup title="Prices">
                            <p className="text-sm">$120 - $300</p>
                            <input type="range" className="w-full mt-2" />
                        </FilterGroup> */}

                        <FilterGroup title="STEP 1: Select Category">
                            {cookies?.userProfile?.categories?.map(b => (
                            <label key={b.id} className="flex items-center gap-2 mb-1 md:mb-0 text-sm mr-2 md:mr-0">
                                <input disabled={(categoryFilter !== "" && categoryFilter != b.id) ? true : false} onChange={(e) => addFilter(e.target.checked, b.id)} type="checkbox" /> {b.name}
                            </label>
                            ))}
                        </FilterGroup>

                        {(categoryFilter != "" && formFields?.new_category == "") && <FilterGroup title="STEP 2: Select Collection">
                            {subCategories?.map((b, index) => 
                            <label key={b.id} className="flex items-center gap-2 mb-1 md:mb-0 text-sm mr-2 md:mr-0">
                                <input disabled={(subCategoryFilter !== "" && subCategoryFilter != b.id) ? true : false} onChange={(e) => addSubFilter(e.target.checked, b.id)} type="checkbox" /> {b.name}
                            </label>
                            )}
                        </FilterGroup>}

                        {(categoryFilter != "" && subCategoryFilter == "") && <FilterGroup title="OR">
                            <input
                                className="w-full bg-gray-100 rounded px-4 py-2 mt-1"
                                value={formFields?.new_category}
                                placeholder="Create new collection..."
                                onChange={(e) => setFormFields({...formFields, new_category: e.target.value})}
                            />
                        </FilterGroup>}
                    </aside>
                    </div>
                    <div className="flex-1 px-4">
                        <h1 className="text-lg font-bold text-gray-800 mb-6">STEP 3: Product Details</h1>
                        <div className="flex inline-flex flex-wrap w-full justify-between">
                            <div className='w-[45%]'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Name <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="h-[45px] w-full px-3 py-1 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-yellow"
                                    placeholder="Enter name"
                                    onChange={(e) => setFormFields({...formFields, name: e.target.value})}
                                />
                            </div>
                            <div className='w-[45%]'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Base Price (NGN)<span className="text-red-500">*</span>
                                </label>
                                <input
                                    // type="number"
                                    className="h-[45px] w-full px-3 py-1 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-yellow"
                                    placeholder="Enter price"
                                    // value={formatAmount(formFields?.base_price)}
                                    // onChange={(e) => setFormFields({...formFields, base_price: e.target.value})}
                                    value={formatAmount(formFields?.base_price)}
                                    onChange={(e) => {
                                        const raw = parse(e.target.value);
                                        // allow only numbers
                                        raw.replace(/,/g, '');
                                        if (!/^\d*$/.test(raw)) return;
                                        setFormFields({...formFields, base_price: raw})
                                    }}
                                />
                            </div>
                            <div className='w-full flex flex-col my-2'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Upload Images or Videos:
                                </label>
                                <input
                                    type="file"
                                    className="w-full mx-auto border p-2 rounded"
                                    accept="image/*,video/*"
                                    multiple
                                    onChange={handleFileChange}
                                />
                            </div>
                            <div className='w-full flex inline-flex flex-wrap justify-start mt-3 gap-x-1'>
                                {images?.map((item, index) => {
                                    const url = URL.createObjectURL(item);
                                    const isVideo = item.type.startsWith("video/");
                                    return(
                                    <>
                                        {isVideo ? (
                                        <video
                                            src={url}
                                            className="w-[8em] h-[8em] object-cover"
                                            muted
                                            controls
                                            autoPlay={false}
                                        />
                                        ) : (
                                        <img
                                            src={URL.createObjectURL(item)}
                                            alt="Preview"
                                            className="w-[8em] h-[8em] object-cover rounded"
                                        />
                                        )}
                                    </>
                                    )
                                })}
                            </div>
                            <div className="w-full mt-3 flex flex-col gap-y-2">
                                <div className="flex flex-wrap gap-2 border rounded-lg p-2 bg-white">
                                    <button size="sm" variant="outline" onClick={() => exec("bold")}>
                                    <FaBold size={16} />
                                    </button>
                                    <button size="sm" variant="outline" onClick={() => exec("italic")}>
                                    <FaItalic size={16} />
                                    </button>
                                    {/* Decrease font size */}
                                    <button
                                        type="button"
                                        onClick={decreaseFontSize}
                                        className="border rounded px-2 py-1 text-sm"
                                    >
                                        A-
                                    </button>

                                    {/* Increase font size */}
                                    <button
                                        type="button"
                                        onClick={increaseFontSize}
                                        className="border rounded px-2 py-1 text-sm"
                                    >
                                        A+
                                    </button>

                                    {/* Font color */}
                                    <input
                                        type="color"
                                        onChange={(e) => exec("foreColor", e.target.value)}
                                        className="w-8 h-8 p-0 border rounded cursor-pointer"
                                        title="Text color"
                                    />
                                </div>
                                <div
                                    ref={editorRef}
                                    contentEditable
                                    className="min-h-[300px] bg-[#ffffff] border rounded-lg p-4 bg-white focus:outline-none"
                                    placeholder="Write your post content here..."
                                    onInput={() => {setContent(editorRef.current.innerHTML); setFormFields({...formFields, description: editorRef.current.innerHTML }) }}
                                />

                                {/* Preview / Debug */}
                                {/* <div className="text-sm text-gray-500">
                                    <p>Description Preview:</p>
                                    <pre className="bg-gray-100 p-2 rounded text-xs overflow-x-auto">
                                    {content}
                                    </pre>
                                </div> */}
                            </div>
                            <label className='text-md font-bold my-2'>Product Addons</label>
                            <div className='w-full flex inline-flex flex-wrap justify-between mt-3'>
                                {extras.map((item, index) => (
                                    <div
                                    key={index}
                                    className="w-[45%] my-1 grid grid-cols-1 gap-3 border p-4 rounded-lg"
                                    >
                                    <input
                                        type="text"
                                        placeholder="Group (e.g Cup Size)"
                                        value={item.extra_group}
                                        onChange={(e) =>
                                        handleChange(index, "extra_group", e.target.value)
                                        }
                                        className="border rounded px-3 py-2"
                                    />

                                    <input
                                        type="text"
                                        placeholder="Option (e.g 38F)"
                                        value={item.extra_option}
                                        onChange={(e) =>
                                        handleChange(index, "extra_option", e.target.value)
                                        }
                                        className="border rounded px-3 py-2"
                                    />

                                    <input
                                        // type="number"
                                        placeholder="Price (10,000 (NGN))"
                                        // value={formatAmount(item.amount_plus)}
                                        // onChange={(e) =>
                                        // handleChange(index, "amount_plus", e.target.value)
                                        // }
                                        value={formatAmount(item.amount_plus)}
                                        onChange={(e) => {
                                            const raw = parse(e.target.value);
                                            // allow only numbers
                                            raw.replace(/,/g, '');
                                            if (!/^\d*$/.test(raw)) return;
                                            handleChange(index, "amount_plus", raw)
                                        }}
                                        className="border rounded px-3 py-2"
                                    />

                                    <button
                                        type="button"
                                        onClick={() => removeRow(index)}
                                        disabled={extras.length === 1}
                                        className="bg-red-500 text-white rounded px-3 py-2 disabled:opacity-40"
                                    >
                                        Remove
                                    </button>
                                    </div>
                                ))}
                            </div>
                            <div className="flex gap-3 my-2">
                                <button
                                type="button"
                                onClick={() => addRow()}
                                className="bg-blue-600 text-white px-4 py-2 rounded"
                                >
                                + Add Addons
                                </button>
                            </div>
                        </div>
                        <div className='w-full mt-3 flex justify-end'>
                            <button 
                                className="px-5 bg-secondary h-[40px] flex items-center justify-center text-white w-auto rounded hover:bg-secondary"
                                onClick={() => submit()}>
                                Upload Product
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

function FilterGroup({ title, children }) {
  return (
    <div className="mb-3 md:mb-6">
      <h4 className="font-semibold mb-2">{title}</h4>
      <div className="flex flex-wrap md:flex-col md:space-y-2">{children}</div>
    </div>
  )
}
